import { MetaReducer, ActionReducer, Action } from "@ngrx/store";
import { RootState } from "./root";

export function resetMetaReducer(reducer): ActionReducer<RootState, Action> {
    return (state, action) => {
        return reducer(
            action.type === ResetStore.type ? undefined : state,
            action,
        );
    };
}

export class ResetStore implements Action {
    static readonly type = "root/reset";
    readonly type = ResetStore.type;
}
